import React, { useState } from "react";
import "./css/Home.css";
import HiringBanner from "../components/HiringBanner";
import productsData from "../json/products.json";
import divisionsData from "../json/divisions.json";

const Home = ({ onNavigate }) => {
  const [showContactForm, setShowContactForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;
    const subject = `Ready To Go Vyral: ${name}`;
    const body = `Name: ${name}%0D%0AEmail: ${email}%0D%0A%0D%0AMessage:%0D%0A${message}`;
    window.location.href = `mailto:devilking6105@gmail.com?subject=${encodeURIComponent(subject)}&body=${body}`;
    setFormSubmitted(true);
    setFormData({ name: "", email: "", message: "" });
  };

  const products = [
    {
      id: "vyral-social",
      name: "VyralSocial",
      description:
        "A social media platform where users engage, earn rewards, and earn badges with our 'Be Official' program.",
      status: "Active",
    },
    {
      id: "vyral-news",
      name: "VyralNews",
      description:
        "Your source for breaking news, in-depth journalism, and real-time coverage of stories that matter across technology, entertainment, and culture.",
      status: "Active",
    },
    {
      id: "vyral-fans",
      name: "VyralFans",
      description:
        "A premium content platform where creators connect with their audience through exclusive content and subscriptions.",
      status: "Active",
    },
    {
      id: "vyral-swing",
      name: "VyralSwingLife",
      description:
        "A sophisticated community for the swinger lifestyle. Connect authentically, explore safely, and embrace your desires with like-minded individuals and couples.",
      status: "Active",
    },
    {
      id: "president-band-street-team",
      name: "President Band Campaign Street Team",
      description:
        "The official street team platform for President Band. Fans join missions, earn rewards, attend concerts, and drive the campaign from the ground up.",
      status: "Active",
    },
    {
      id: "vyral-reflect",
      name: "VyralReflect",
      description:
        "VyralReflect is a short form video platform where users post videos and AI Reflect, will give you a reply at the end of your video",
      status: "In Testing",
    },
    {
      id: "vyral-streams",
      name: "VyralStreams",
      description:
        "A live streaming platform for creators to broadcast, interact, and build their communities in real-time.",
      status: "In Testing",
    },
    {
      id: "vyral-productions",
      name: "VyralProductions",
      description:
        "Full-service branding, advertising, and custom application development for businesses and creators.",
      status: "In Testing",
    },
    {
      id: "vyral-music",
      name: "VyralMusic",
      description:
        "Music production, distribution, and a digital music store for artists and listeners.",
      status: "In Testing",
    },
    {
      id: "vyral-mining",
      name: "VyralMining",
      description:
        "A dedicated mining farm soon to be available to users of VyralSocial.",
      status: "In Development",
    },
  ];

  return (
    <div className="home-page">
      <HiringBanner onNavigate={onNavigate} />

      <section className="hero-section">
        <img
          src="/vyral.png"
          alt="Vyral Media Group Logo"
          className="hero-logo"
        />
        <h1 className="hero-title">Vyral Media Group</h1>
        <p className="hero-tagline">
          Building the Future of Media, Technology & Entertainment
        </p>
        <button className="hero-cta" onClick={() => onNavigate("products")}>
          Explore Our Apps
        </button>
        <div className="hero-stats">
          <div className="stat-item">
            <span className="stat-number">{productsData.length}</span>
            <span className="stat-label">Apps</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">{divisionsData.length}</span>
            <span className="stat-label">Divisions</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">∞</span>
            <span className="stat-label">Possibilities</span>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="section-container">
          <h2>Who We Are</h2>
          <p>
            Vyral Media Group is a powerhouse in media and technology,
            developing innovative applications that empower creators and
            communities. From social platforms and premium content to music
            production, live streaming, and brand building. We bring it all
            under one roof.
          </p>
          <button className="section-cta" onClick={() => onNavigate("about")}>
            Learn More
          </button>
        </div>
      </section>

      <section className="products-section" id="products-section">
        <div className="section-header">
          <h2>Our Apps</h2>
          <p className="section-subtitle">
            Each app is a unique experience within the Vyral ecosystem
          </p>
        </div>
        <div className="products-grid">
          {products.map(({ id, name, description, status }) => (
            <article
              key={id}
              className="product-card"
              onClick={() => onNavigate("productShowcase", id)}
            >
              <div className="card-header">
                <h3>{name}</h3>
                <span
                  className={`status-badge ${status === "Active" ? "active" : status === "In Testing" ? "testing" : "development"}`}
                >
                  {status}
                </span>
              </div>
              <p className="card-description">{description}</p>
              <div className="card-footer">
                <span className="learn-more">Learn More →</span>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="divisions-section">
        <div className="section-header">
          <h2>Our Divisions</h2>
          <p className="section-subtitle">
            Multiple industries, one unified vision
          </p>
        </div>
        <div className="divisions-grid">
          <article
            className="division-card"
            onClick={() => onNavigate("divisionShowcase", "app-development")}
          >
            <div className="division-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <h3>Application Development</h3>
            <p>Custom applications built for the modern world.</p>
            <span className="division-link">Learn More →</span>
          </article>
          <article
            className="division-card"
            onClick={() =>
              onNavigate("divisionShowcase", "music-entertainment")
            }
          >
            <div className="division-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <circle cx="12" cy="12" r="10" />
                <polygon points="10,8 16,12 10,16" />
              </svg>
            </div>
            <h3>Music & Entertainment</h3>
            <p>Record label, music production, and digital distribution.</p>
            <span className="division-link">Learn More →</span>
          </article>
          <article
            className="division-card"
            onClick={() => onNavigate("divisionShowcase", "vyral-productions")}
          >
            <div className="division-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            <h3>Branding & Marketing</h3>
            <p>Brand building, marketing, and advertising solutions.</p>
            <span className="division-link">Learn More →</span>
          </article>
          <article
            className="division-card"
            onClick={() => onNavigate("divisionShowcase", "news-media")}
          >
            <div className="division-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" />
                <path d="M18 14h-8" />
                <path d="M15 18h-5" />
                <path d="M10 6h8v4h-8V6Z" />
              </svg>
            </div>
            <h3>News & Media Agency</h3>
            <p>Digital news and media coverage for the connected world.</p>
            <span className="division-link">Learn More →</span>
          </article>
        </div>
      </section>

      <section className="ready-section">
        <div className="ready-content">
          <h2>Ready To Go Vyral?</h2>
          <div className="ready-messages">
            <p className="ready-main">
              Join the movement. Build with us, create with us, grow with us.
            </p>
            <p className="ready-sub">
              Whether you're a creator, artist, or innovator, we have a platform
              for you.
            </p>
            <p className="ready-sub">
              Partner with Vyral Media Group to bring your vision to life.
            </p>
            <p className="ready-sub">
              Be part of the next generation of social media, entertainment, and
              technology.
            </p>
          </div>

          <button
            className="ready-contact-btn"
            onClick={() => {
              setShowContactForm(!showContactForm);
              setFormSubmitted(false);
            }}
          >
            {showContactForm ? "Close" : "Contact Us"}
          </button>

          {showContactForm && (
            <div className="ready-form-dropdown">
              {formSubmitted ? (
                <div className="ready-success">
                  <p>Your email client should open shortly!</p>
                  <button onClick={() => setFormSubmitted(false)}>
                    Send Another
                  </button>
                </div>
              ) : (
                <form onSubmit={handleFormSubmit} className="ready-form">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleFormChange}
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleFormChange}
                    required
                  />
                  <textarea
                    name="message"
                    placeholder="Tell us about your project or idea..."
                    value={formData.message}
                    onChange={handleFormChange}
                    rows="4"
                    required
                  />
                  <button type="submit" className="ready-submit-btn">
                    Send Message
                  </button>
                </form>
              )}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Home;
